import { LitElement } from 'lit';
import Glider from 'glider-js';
import { registerAutoplay } from './lib/autoplay';

class ToujouSlider extends LitElement {
  static get is() {
    return 'toujou-slider';
  }

  static get properties() {
    return {
      breakpoints: {
        type: Array,
      },
      slidesToShow: {
        type: Number,
        attribute: 'slides-to-show',
      },
      slidesToScroll: {
        type: Number,
      },
      draggable: {
        type: Boolean,
      },
      rewind: {
        type: Boolean,
      },
      autoPlay: {
        type: Number,
        attribute: 'auto-play',
      },
    };
  }

  constructor() {
    super();
    this.settings = {
      prevControlSelector: '.slider__control--prev',
      nextControlSelector: '.slider__control--next',
      dotsSelector: '.slider__pagination',
      sliderFrameSelector: '.slider__frame',
    };

    this.slidesToShow = 1;
    this.slidesToScroll = 1;
    this.draggable = true;
    this.rewind = true;

    /** @type {Number} */
    this.autoPlay = null;
    this.breakpoints = undefined;

    /** @type {Glider} */
    this._slider = null;
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();

    this._initSlider();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    if (this._slider == null) {
      return;
    }
    const sliderOptions = this._sliderOptions;
    this._slider.setOption(this._sliderOptions, typeof sliderOptions.responsive !== 'undefined');
  }

  _initSlider() {
    this._slider = new Glider(this.querySelector(this.settings.sliderFrameSelector), {
      ...this._sliderOptions,
      arrows: {
        prev: this.querySelector(this.settings.prevControlSelector),
        next: this.querySelector(this.settings.nextControlSelector),
      },
      dots: this.querySelector(this.settings.dotsSelector),
    });

    if (this.autoPlay !== null) {
      registerAutoplay(this._slider, this, this.autoPlay);
    }
  }

  get _sliderOptions() {
    return {
      slidesToShow: this.slidesToShow,
      slidesToScroll: this.slidesToScroll,
      draggable: this.draggable,
      rewind: this.rewind,
      scrollLock: true,
      resizeLock: true,
      responsive: this.breakpoints,
    };
  }
}
customElements.define(ToujouSlider.is, ToujouSlider);
